module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/placeholder.fa6c340.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/placeholder.jpg
// module id = mZAy
// module chunks = 0